import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalEmittersService } from './global-emitters.service';
import { MsalService } from '@azure/msal-angular';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APIRes } from '../Modules/idms/models/commonAPI.model';
import { DataSheetReport, ReportList } from '../Modules/informate/models/reports/data-sheet-report.model';
import { JointCompletionCertificate } from '../Modules/informate/models/reports/joint-completion-certificate.model';
import { ITRReport } from '../Modules/informate/models/reports/itr-report.model';
import { ActivityStatusType, activityPackTypeList } from '../Modules/management/models/instance/activity-pacck-type.model';
import { BarcodeResponseModel } from '../Modules/idms/models/barcodeResponseModel';
import { environment } from 'src/environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { EnvironmentService } from './environment.service';
import { Projects } from '../Modules/idms/components/project-manager/models/project.model';
import { UserUtilityService } from './user-utility.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ManagementApiService } from './management-api.service';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
    providedIn: 'root',
})
export class ReportApiService {
    instanceId: string;
    headers: HttpHeaders;
    private subVal = '';
    private reportApi = environment.reportApi;
    private reportApp = environment.reportApp;
    private logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
    reportData: DataSheetReport | JointCompletionCertificate | DataSheetReport[] | JointCompletionCertificate[];

    constructor(
        private http: HttpClient,
        private globalEmitterService: GlobalEmittersService,
        private authService: MsalService,
        // private reportApiService: ReportApiService,
        private userUtilityService: UserUtilityService,
        private ngXUiLoaderService: NgxUiLoaderService,
        private managementApiService: ManagementApiService,
        private EnvironmentService: EnvironmentService,
        private appInsights: ApplicationInsights,
        private transLocoService: TranslocoService
    ) {
        var _config = EnvironmentService.getConfig();
        this.subVal = _config.subValue;

        this.instanceId = `${localStorage.getItem('currentInstanceId')}`;
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
        });
    }

    addPostAndPutHeaders() {
        this.headers = new HttpHeaders();
        this.headers = this.headers.append('Ocp-Apim-Subscription-Key', this.subVal);
        this.headers = this.headers.append('content-type', 'application/json');
        this.headers = this.headers.append('Accept', 'application/json');
        this.headers = this.headers.append('Access-Control-Allow-Origin', '*');
        this.headers = this.headers.append('Content-Type', 'multipart/form-data');
        this.headers = this.headers.append('Authorization', `Bearer ${localStorage.getItem('msal.accessToken')}`);
        this.headers = this.headers.append('InstanceId', `${localStorage.getItem('currentInstanceId')}`);
    }

    //Method for getting Reports
    //Method for getting Reports
    getReport(payload, url: string): Observable<APIRes<DataSheetReport[] | JointCompletionCertificate[] | ITRReport[] | any>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.reportApi}reports/${url}`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
        // return this.http.post(`https://localhost:7272/api/reports/${url}`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //Method for getting report List by Instance
    getReportList(): Observable<APIRes<ReportList[]>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.reportApi}reports`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to save is favourite flag
    saveIsfavourite(data: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.reportApi}reports/favourite`, data, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //Method for getting all ActivityPacks
    getAllActivityPacks(link: string, activityPackType?: any): Observable<APIRes<activityPackTypeList[] | ActivityStatusType[]>> {
        const url = `${this.reportApi}reports/${link}`; //`
        this.addPostAndPutHeaders();
        return this.http.post(url, activityPackType ? activityPackType : {}, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //Method for getting all ActivityPacks
    getProjectTypesAndProjects(link: string, projectType?: any): Observable<APIRes<any>> {
        const url = `${this.reportApi}reports/${link}`; //`
        this.addPostAndPutHeaders();
        return this.http.post(url, projectType ? projectType : {}, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //Method for getting all projects
    getAllViews(reportId: string): Observable<APIRes<any[]>> {
        const url = `${this.reportApi}reports/getreportdata/${reportId}`; //`
        this.addPostAndPutHeaders();
        return this.http.post(url, {}, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //Method for getting  Reports
    getbarcodeInfo(barcodeNo: string): Observable<APIRes<BarcodeResponseModel>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.reportApi}barcode/${barcodeNo}`, {}, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    exportReport(payload) {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.reportApp}api/export/ExportToPDF`, payload, { headers: this.headers, responseType: 'blob' })
            .pipe(catchError(this.handleError.bind(this)));
    }

    exportMultipleReports(payload) {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.reportApp}api/export/ExportMultipleReports`, payload, { headers: this.headers, responseType: 'blob' })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getpacksheet(payLoad?: any, reportId?: string): Observable<APIRes<any[]>> {
        const url = `${this.reportApi}reports/getreportdata/${reportId}`; //`
        this.addPostAndPutHeaders();
        return this.http.post(url, payLoad, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getpacksheetFromWorkPack(payLoad?: any): Observable<APIRes<any[]>> {
        const url = `${this.reportApi}reports/getpacksheet`; //`
        this.addPostAndPutHeaders();
        return this.http.post(url, payLoad, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    getdashboardjazan(reportId: string): Observable<APIRes<any[]>> {
        const url = `${this.reportApi}reports/getreportdata/${reportId}`; //`
        this.addPostAndPutHeaders();
        return this.http.post(url, {}, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    private handleError(error: any) {
        this.logedInUserId = this.authService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        let currOrg = localStorage.getItem('selectedOrgId');
        let currInstance = localStorage.getItem('currentInstanceId');
        if (error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.message);

            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
            //this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId } });
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.message}`);
            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId },
            });
            //this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.logedInUserId } });
        }
        // Return an observable with a user-facing error message.
        return throwError('Something bad happened; please try again later.');
    }

    async callReports(reportName: string, reportData, reportType: string) {
        try {
            let resp = await this.getReport(reportData, reportType).toPromise();
            if (resp.success) {
                this.reportData = resp.response;
                if (localStorage.getItem('currentInstanceTypeName').toLowerCase() == 'idms') {
                    try {
                        let res = await this.managementApiService.getSettingProfileAreaId('iDMS').toPromise();

                        if (res.success) {
                            let settingArea = res.response;

                            let _res = await this.managementApiService
                                .getInstanceDefaultSettings(settingArea.settingAreaId, localStorage.getItem('currentInstanceId'))
                                .toPromise();

                            if (_res.success) {
                                var InstanceSettings = _res.response;
                                if (InstanceSettings) {
                                    // Find the setting with key "ReportQRCode_Visible"
                                    const setting = InstanceSettings.find((item) => item.userPreferenceKey === 'ReportBarcode_Visible');

                                    // Extract the "value" from "settingValue" if found
                                    const isBarcodeVisible = setting?.userPreference;
                                    // Find the setting with key "ReportQRCode_Visible"
                                    const _setting = InstanceSettings.find((item) => item.userPreferenceKey === 'ReportQRCode_Visible');

                                    // Extract the "value" from "settingValue" if found
                                    const isQRcodeVisible = _setting?.userPreference;
                                    const isQRVisible = isQRcodeVisible.toLowerCase() === 'true';
                                    const isBarcodeVisibleFlag = isBarcodeVisible.toLowerCase() === 'true';

                                    if (Array.isArray(this.reportData)) {
                                        // Case: Array of rows
                                        this.reportData.forEach((row) => {
                                            row.isQRcodeVisible = isQRVisible;
                                            row.isBarcodeVisible = isBarcodeVisibleFlag;
                                        });
                                    } else if (this.reportData) {
                                        // Case: Single object
                                        this.reportData['isQRcodeVisible'] = isQRcodeVisible.toLowerCase() == 'true' ? true : false;
                                        this.reportData['isBarcodeVisible'] = isBarcodeVisible.toLowerCase() == 'true' ? true : false;
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        this.ngXUiLoaderService.stop();
                    }
                }

                if (Array.isArray(this.reportData)) {
                    this.reportData.forEach((row) => {
                        row.language = this.transLocoService.getActiveLang();
                    });
                } else if (this.reportData) {
                    this.reportData['language'] = this.transLocoService.getActiveLang();
                }

                if (resp.response && resp.response.length > 1) {
                    this.ngXUiLoaderService.start();
                    let rptData = {
                        ReportName: reportName,
                        DatasheetReportData: this.reportData,
                        JointCompletionCertificateData: this.reportData,
                        ITRReport: this.reportData,
                        Formate: 'pdf',
                    };
                    this.exportMultipleReports(rptData).subscribe((response) => {
                        const blob = new Blob([response], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');

                        // avoid open redirect vulnerabilities by validating generated URL
                        if (url && url.startsWith('blob:')) {
                            window.open(url, '_blank', 'noopener,noreferrer');
                        }
                        setTimeout(() => window.URL.revokeObjectURL(url), 1000);

                        this.ngXUiLoaderService.stop();
                    });
                } else {
                    this.ngXUiLoaderService.start();
                    let rptData = {
                        ReportName: reportName,
                        DatasheetReportData: this.reportData[0],
                        JointCompletionCertificateData: this.reportData[0],
                        ITRReport: this.reportData[0],
                        Formate: 'pdf',
                    };
                    this.exportReport(rptData).subscribe((response) => {
                        const blob = new Blob([response], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');

                        if (url && url.startsWith('blob:')) {
                            window.open(url, '_blank', 'noopener,noreferrer');
                        }
                        setTimeout(() => window.URL.revokeObjectURL(url), 1000);

                        this.ngXUiLoaderService.stop();
                    });
                }
            } else {
                this.userUtilityService.errorModelPopup(resp?.message || 'Error while fetching the report');
            }
        } catch (err) {
            this.ngXUiLoaderService.stop();
            this.userUtilityService.errorModelPopup('Error');
        }
    }
}
